<template>
  <div class="text-center">
    <v-form ref="form" @submit.prevent="submitForm">
      <v-text-field v-model="token" label="Password reset token"></v-text-field>
      <v-text-field
        v-model="password"
        type="password"
        :rules="passwordRules"
        label="New password"
        hint="Must be between 8 and 20 characters"
        @input="checkPasswordValidity"
      ></v-text-field>
      <v-text-field
        v-model="confirmPassword"
        type="password"
        label="Confirm new password"
        @input="checkPasswordValidity"
      ></v-text-field>
      <v-btn
        type="submit"
        class="white--text"
        width="100%"
        color="#4d51c5"
        rounded
        :disabled="isDisabled"
        >Reset password</v-btn
      >
    </v-form>
    <div style="width: 100%; height: 20px">
      <span v-show="showMessage" :style="messageStyle">{{ messageText }}</span>
    </div>
  </div>
</template>

<script>
import services from "../rest/Services";

export default {
  data() {
    return {
      token: "",
      password: "",
      confirmPassword: "",
      messageText: "",
      showMessage: false,
      messageColor: "green",
      passwordRules: [
        (v) =>
          /(?=.*[a-z])/.test(v) || "Password must contain a lowercase letter",
        (v) =>
          /(?=.*[A-Z])/.test(v) || "Password must contain an uppercase letter",
        (v) => /(?=.*\d)/.test(v) || "Password must contain a number",
        (v) =>
          /(?=.*[!@#$%^&*()_+~`|}{[\]\\:;'<>,.?/])/.test(v) ||
          "Password must contain a special character",
        (v) => /.{8,}/.test(v) || "Password must be at least 8 characters long",
      ],
      isDisabled: true,
    };
  },
  methods: {
    submitForm() {
      if (this.password !== this.confirmPassword) {
        this.showMessage = true;
        return;
      }
      let params = {
        token: this.token,
        new_password: this.password,
      };
      services
        .consumePasswordResetToken(params)
        .then((response) => {
          console.log("response :>> ", response);
          this.createMessage(true);
          this.$refs.form.reset();
          //this.$refs.form.resetValidation();
        })
        .catch((error) => {
          console.log("error :>> ", error);
          this.createMessage(false);
        });
    },
    createMessage(isSuccess) {
      this.messageText = isSuccess
        ? "Password reset successfully. Try to login with new password."
        : "Password reset failed. Please try again.";
      this.messageColor = isSuccess ? "green" : "red";
      this.showMessage = true;
      setTimeout(() => {
        this.showMessage = false;
      }, 5000);
    },
    checkPasswordValidity() {
      if (this.$refs.form.validate() && this.confirmPassword === this.password)
        this.isDisabled = false;
      else this.isDisabled = true;
    },
  },
  computed: {
    messageStyle() {
      return {
        color: this.messageColor,
      };
    },
  },
};
</script>
